import timg1 from '../images/team/team_member_image_1.webp'
import timg2 from '../images/team/team_member_image_2.webp'
import timg3 from '../images/team/team_member_image_3.webp'
import timg4 from '../images/team/team_member_image_4.webp'
import timg5 from '../images/team/team_member_image_5.webp'


const Teams = [
   {
      Id: '1',
      tImg: timg1,
      name: 'Atticus Sterling',
      slug: 'Atticus-Sterling',
      title: 'Systems Engineer',
   },
   {
      Id: '2',
      tImg: timg2,
      name: 'Orion Jasper',
      slug: 'Orion-Jasper',
      title: 'IT Consultant',
   },
   {
      Id: '3',
      tImg: timg3,
      name: 'August Everest',
      slug: 'August-Everest',
      title: 'systems engineer',
   },
   {
      Id: '4',
      tImg: timg4,
      name: 'Maverick Phoenix',
      slug: 'Maverick-Phoenix',
      title: 'data analyst',
   },
   {
      Id: '5',
      tImg: timg5,
      name: 'Daxton Atlas',
      slug: 'Daxton-Atlas',
      title: 'Project Manager',
   },
   {
      Id: '6',
      tImg: timg4,
      name: 'Maverick Phoenix',
      slug: 'Maverick-Phoenix',
      title: 'data analyst',
   },
   
]

export default Teams;